import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue';
import ATooltip, { TooltipPlacement } from 'ant-design-vue/es/tooltip';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiTooltip',
  props: {
  title: {
    type: String,
    default: '',
  },
  placement: {
    type: String as PropType<TooltipPlacement>,
    default: 'top',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ATooltip), {
    title: __props.title,
    placement: __props.placement
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["title", "placement"]))
}
}

})